// extracted by mini-css-extract-plugin
export var csatScore = "_jr-5";
export var header = "_jr-1";
export var panelWrapper = "_jr-2";
export var postPreview = "_jr-3";
export var rightContent = "_jr-0";
export var wrappingText = "_jr-4";